import axios from "axios";
import React, { useEffect, useState } from "react";

interface NewsStructure {
  id:number;
  title:string;
  img:string;
  desc:string;
  date:string;
}

const MenuPage = () => {
   const api = process.env.REACT_APP_API_URL as string;
    const [newData, setNewData] = useState<NewsStructure[]>([]);

    
      useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get<NewsStructure[]>(
              `${api}/auth/news`
            );
    
            //console.log('news data',response.data)
            setNewData(response.data);
            console.log('menu page news data ', newData);
            //console.log("news data in a array",newData);
          } catch (error) {
            console.error("Post Not Found:", error);
          }
        };
    
        fetchData();
      }, []);
  const newsData2 = [
    {
      id: 1,
      image: "/src/images/indianews.webp",
      title: "Mines dept revenue up by 4% under strict monitoring",
      location: "Jaipur",
      summary:
        "Chief Minister Bhajan Lal Sharma and Principal Secretary T Ravikanth's strict policy and monitoring h...",
    },
    {
      id: 2,
      image: "/src/images/indianews2.webp",
      title: "NEET aspirant falls off stairs in Kota, dies",
      location: "Kota:",
      summary:
        "In a tragic incident, a coaching student died after falling from the stairs in a hostel in Vigyan Nagar area ..",
    },
    {
      id: 3,
      image: "/src/images/indianews3.webp",
      title: "Devnani honours meritorious students, urges them to aim high",
      location: "Jaipur",
      summary:
        "Jaipur: Assembly Speaker Vasudev Devnani attended a Pratibha Samman ceremony of a private school to honour talents ..",
    },
    {
      id: 4,
      image: "/src/images/indianews4.webp",
      title: "PEELUPURA BOILS BUT PACIFIED",
      location: "Bharatpur/Karauli/Sawai Madhopur:",
      summary:
        "The Gurjar community held a mahapanchayat at Peelupura near Bayana in Bharatpur o..",
    },
    {
      id: 5,
      image: "/src/images/indianews5.webp",
      title: "JMCG starts yoga drive at Biodiversity Park",
      location: "Jaipur",
      summary:
        "Jaipur: Jaipur Municipal Corporation Greater Mayor Dr Somya launched a campaign to make Jaipur a center of yoga at ..",
    },
    {
      id: 6,
      image: "/src/images/indianews6.webp",
      title: "Temple road closed over tiger sighting, devotees fume",
      location: "Jaipur",
      summary:
        "Sawai Madhopur: A large number of devotees who arrived to have a darshan of Trinetra Ganesh became furious for..",
    },
    {
      id: 7,
      image: "/src/images/indianews7.webp",
      title: "973 kg poppy husk seized in Chittorgarh by CBN",
      location: "Jaipur",
      summary:
        "Chittorgarh: In an anti-drug operation in Rajasthan, the Central Narcotics Bureau (CBN) Chittorgarh cell intercepte..",
    },
    {
      id: 8,
      image: "/src/images/indianews8.webp",
      title: "Pre-monsoon mess: Drains of neglect",
      location: "Jaipur",
      summary:
        "Jaipur: With the monsoon looming, authorities are showcasing drain cleaning efforts on a war footing. However, in r..",
    },
    {
      id: 9,
      image: "/src/images/indianews9.webp",
      title:
        "Train services disrupted after Gurjar community blocks tracks in Bayana",
      location: "Jaipur",
      summary:
        "Bharatpur: Gurjar community people on Sunday blocked railway tracks at Peelupura in Bayana, disrupting train moveme..",
    },
    {
      id: 10,
      image: "/src/images/indianews10.webp",
      title: "THE ONE-MAN SHOW OF POWER!",
      location: "Jaipur",
      summary:
        "Jaipur: The year 2025 marks 11 years of Prime Minister Narendra Modi’s tenure, the government reflects on a p..",
    },
    {
      id: 11,
      image: "/src/images/indianews11.webp",
      title: "Narendra Modi 11 years of transformation leadership",
      location: "Jaipur",
      summary:
        "As Prime Minister Narendra Modi completes eleven remarkable years in office today, India stands as a testament to transformative leadersh..",
    },
    {
      id: 12,
      image: "/src/images/indianews12.webp",
      title:
        "MP: Fire erupts at Garment factory in Burhanpur, firefighting operations underway",
      location: "Jaipur",
      summary:
        "Burhanpur : A fire broke out at a garment factory in Burhanpur on Sunday. The firefighting operations are currently unde..",
    },
    {
      id: 13,
      image: "/src/images/indianews13.webp",
      title:
        "Atishi writes to Amit Shah over sexual assault of minor in Dayalpur; says, incident has put Delhi to shame",
      location: "Jaipur",
      summary:
        "New Delhi : Aam Aadmi Party (AAP) leader and former Delhi Chief..",
    },
    {
      id: 14,
      image: "/src/images/indianews14.webp",
      title:
        "IAF to get Rs 10,000 crore indigenous I-STAR spy planes to help in precision strikes against enemy ground targets",
      location: "Jaipur",
      summary:
        "New Delhi : Amid the ongoing Operation Sindoor against Pakistan, the Defence Ministry is going to take up Rs 10,000 cror..",
    },
  ];

  const [visibleCount, setVisibleCount] = useState(10);
  const [loading, setLoading] = useState(false);

  const handleLoadMore = () => {
    setLoading(true);
    setTimeout(() => {
      setVisibleCount((prev) => prev + 4);
      setLoading(false);
    }, 1000);
  };
  return (
    <div className='p-4 w-[50%] mx-auto'>
      <h2 className="text-3xl font-bold text-red-700 border-b border-gray-300 mb-4">INDIA &gt;</h2>
      <div className='space-y-4'>
        {newData.map((item) => (
          <div key={item.id} className='flex gap-4 border-b pb-4'>
            <img src={`${api}/${item.img}`} alt={item.title}
              className="w-[300px] h-[170px] object-cover rounded" />
            <div>
              <a href=""></a>
              <h3 className="font-bold text-2xl hover:text-red-700 cursor-pointer" onClick={() => {
            window.location.href = `/news/${item.id}`;
          }}>{item.title}</h3>
              <p className="text-xl text-gray-600">
                {/* <span className="font-medium">{item.}:</span> {item.summary} */}
              </p>
            </div>
          </div>
        ))}
      </div>

      {loading && (
        <div className="flex justify-center mt-6 gap-2">
          <span className="w-3 h-3 bg-red-500 rounded-full animate-bounce"></span>
          <span className="w-3 h-3 bg-yellow-500 rounded-full animate-bounce [animation-delay:200ms]"></span>
          <span className="w-3 h-3 bg-blue-500 rounded-full animate-bounce [animation-delay:400ms]"></span>
        </div>
      )}

      {!loading && visibleCount < newData.length && (
        <div className='text-center mt-6'>
          <button
            onClick={handleLoadMore}
            className='bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2 rounded-md shadow-md transition-all'
          >
            Load More
          </button>
        </div>
      )}
    </div>
  )
};

export default MenuPage;
